// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#logo { width:100px; height: 100px; }", "",{"version":3,"sources":["webpack://./src/app/sidenav-header/sidenav-header.component.ts"],"names":[],"mappings":"AAAA,QAAQ,WAAW,EAAE,aAAa,EAAE","sourcesContent":["#logo { width:100px; height: 100px; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
